import { atom } from 'recoil';

const keyWordListState = atom<any>({
  key: 'keyWord/keyWordList',
  default: [],
});

export { keyWordListState };
